<template>
  <div class="dash-library__list-item">
    <a class="dash-library__link" v-on:click="downloadPricing">
      <div class="dash-library__name" v-cloak><i class="fa fa-file documents__link-icon"></i> {{ document.name }}</div>
    </a>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'Document',
    props: {
      document: {
        type: Object,
      },
    },
    computed: {
      ...mapGetters('library', ['downloadInProgress']),
    },
    methods: {
      downloadPricing() {
        if (this.downloadInProgress) {
          return;
        }
        this.$store.dispatch('library/downloadPricing', this.document.name);
      },
    },
  }
</script>

